<qbuilt-navbar class="nav-bar-styling" [isHomePage]="false"></qbuilt-navbar>
@if(isLoading || saveProgressLoad) {
    <div class="loading-spinner">
        <mat-spinner diameter="300" class="secret"></mat-spinner>
    </div>
} @else {
<div class="page-container">
    <div class="new-serial-tab">
        <button mat-icon-button class="new-tab" (click)="addNewSerial(selected)">
            {{newTabText}}
        </button>
        <hr class="hr-styling">
        <button mat-icon-button
            [ngClass]="{'save-progress-disabled': !defectLocationCheck() || !submitSignoffCheck(), 'save-progress': defectLocationCheck() || submitSignoffCheck()}" 
            [disabled]="!defectLocationCheck() || !submitSignoffCheck()" (click)="saveInspectionProgress()">
            {{saveProgressText}}
        </button>
        @if(!defectLocationCheck() || !submitSignoffCheck()) {
            <mat-icon [matTooltip]="getToolTipText()" class="warning-icon">info</mat-icon>
        }
    </div>
    <div class="tabs">
        <mat-tab-group class="tab-group" [selectedIndex]="selected" (selectedIndexChange)="tabSelection($event)"
        mat-stretch-tabs="false" mat-align-tabs="start">
        @for (tab of tabList; track tab; let index = $index) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="tab-styling">{{ tab.serialNumber }}</span>
                    <!--  TODO -- commenting out for now but may use later
                    @if(tab.warning) {
                        <mat-icon class="warning-icon" color="warn">circle</mat-icon>
                    } -->
                </ng-template>
                <ng-template matTabContent>
                    @if(tabLoading) {
                        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
                    } @else {
                    <inspection-content [tabData]="tab" (emitContentLoad)="LoadComplete($event)" (emitCompleteTab)="onTabComplete($event)"></inspection-content>
                    }
                </ng-template>
            </mat-tab>
        }
        </mat-tab-group>
    </div>
</div>
}